import axios, { AxiosRequestConfig } from "axios";
import { useErrorModalStore } from "modal/error/errorModalStore";

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config: any) => {
  const token = sessionStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers ?? ({} as any);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config as
      | (AxiosRequestConfig & { _retry?: boolean })
      | undefined;

    if (!status || !originalRequest) {
      return Promise.reject(error);
    }

    if (status === 401) {
      sessionStorage.removeItem("access_token");
      return Promise.reject(error);
    }

    // 403: 권한 오류 -> 모달 노출
    if (status === 403) {
      useErrorModalStore.getState().open(error.response.data.detail.message);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
